import { render } from "./ColorComponent.vue?vue&type=template&id=f1735f46&scoped=true"
import script from "./ColorComponent.vue?vue&type=script&lang=js"
export * from "./ColorComponent.vue?vue&type=script&lang=js"

import "./ColorComponent.vue?vue&type=style&index=0&id=f1735f46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1735f46"]])

export default __exports__